import { render, staticRenderFns } from "./old-payment-importer.vue?vue&type=template&id=68b4813f&scoped=true&"
import script from "./old-payment-importer.vue?vue&type=script&lang=js&"
export * from "./old-payment-importer.vue?vue&type=script&lang=js&"
import style0 from "./old-payment-importer.vue?vue&type=style&index=0&id=68b4813f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b4813f",
  null
  
)

export default component.exports